import { ChangeDetectorRef, Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { SecureStorageService } from 'src/app/core/validators/secure-storage.service';

@Component({
  standalone: false,
  selector: 'app-countdown-timer',
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.css']
})
export class CountdownTimerComponent implements OnInit, OnDestroy {
  timeLeft: number = 3;
  interval: any;
  display: string = '0:00';
  ECLIPSOFT_SMS_TIEMPO_REINTENTO_OTP: number = 0;

  @Output() timerEnded: EventEmitter<any> = new EventEmitter();

  constructor(
    private secureStorageService: SecureStorageService,
    private cdr: ChangeDetectorRef
  ){}

  ngOnInit() {
    const data = JSON.parse(this.secureStorageService.getData('designConfig') || "false");
    if(data){
      this.ECLIPSOFT_SMS_TIEMPO_REINTENTO_OTP = data.ECLIPSOFT_SMS_TIEMPO_REINTENTO_OTP;
      this.timeLeft = this.ECLIPSOFT_SMS_TIEMPO_REINTENTO_OTP;
    }
    this.startTimer();
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        this.display = this.formatTime(this.timeLeft);
        this.cdr.detectChanges();
      } else {
        clearInterval(this.interval);
        this.timerEnded.emit();
        this.cdr.detectChanges();
      }
    }, 1000);
  }

  restartTimer() {
    this.timeLeft = this.ECLIPSOFT_SMS_TIEMPO_REINTENTO_OTP;
    this.display = '0:00';
    clearInterval(this.interval);
    this.startTimer();
    this.cdr.detectChanges();
  }

  formatTime(time: number): string {
    const minutes: number = Math.floor(time / 60);
    const seconds: number = time % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}